import type { AvisoDaSala, SinalDaSala } from '@orbind/core'
import { apiOrigin } from '../../lib/api.ts'

/**
 * O canal ao vivo de quem entra por LINK (SPEC-20260917-0047).
 *
 * É o mesmo endereço do canal de presença, mas a credencial é outra: o token da
 * portaria, e não um JWT de sessão — quem vem pelo link não tem conta. Por isso
 * não dá para reusar `canalDePresenca`, que só sabe autenticar com a sessão
 * guardada no navegador.
 *
 * Este canal não recebe presença, conversa nem nada do workspace: só o que
 * acontece na sala em que a pessoa foi convidada.
 */
export class CanalDoConvidado {
  private socket: WebSocket | null = null
  private aoEvento: ((evento: AvisoDaSala) => void) | null = null

  conectar(guestToken: string, aoEvento: (evento: AvisoDaSala) => void): void {
    this.encerrar()
    this.aoEvento = aoEvento
    const socket = new WebSocket(`${apiOrigin().replace(/^http/, 'ws')}/ws/presence`)
    this.socket = socket

    socket.onopen = () => {
      // O token vai no primeiro quadro, nunca na URL — mesma regra da sessão.
      socket.send(JSON.stringify({ tipo: 'autenticar-convidado', token: guestToken }))
    }
    socket.onmessage = (evento) => {
      if (this.socket !== socket) return
      try {
        const mensagem = JSON.parse(String(evento.data)) as { tipo?: string }
        if (mensagem.tipo === 'sala') this.aoEvento?.(mensagem as AvisoDaSala)
      } catch {
        // quadro estranho: ignorar é mais seguro que derrubar a espera
      }
    }
  }

  entrarNaSala(roomId: string): void {
    this.enviar({ tipo: 'sala-entrar', roomId })
  }

  enviarSinal(para: string, sinal: SinalDaSala): boolean {
    return this.enviar({ tipo: 'sala', para, sinal })
  }

  sair(): void {
    this.enviar({ tipo: 'sala-sair' })
  }

  encerrar(): void {
    const socket = this.socket
    this.socket = null
    this.aoEvento = null
    socket?.close()
  }

  private enviar(payload: unknown): boolean {
    if (this.socket?.readyState !== WebSocket.OPEN) return false
    this.socket.send(JSON.stringify(payload))
    return true
  }
}
